module.exports = __webpack_public_path__ + "img/firewall-ability.1bb527e 2.405f29b.svg";